import { useState, type FormEvent } from 'react';
import { Button } from '@/shared/ui/Button';
import { Input } from '@/shared/ui/Input';
import { MailIcon, SignInIcon } from '@/shared/ui/icons';

interface EmailStepProps {
  submitting: boolean;
  error: string | null;
  onSubmit: (email: string) => void;
  onChange: () => void;
}

export function EmailStep({ submitting, error, onSubmit, onChange }: EmailStepProps) {
  const [email, setEmail] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(email);
  };

  return (
    <form onSubmit={handleSubmit} noValidate className="space-y-6">
      {/* Rótulo só para leitor de tela: o ícone de envelope e o placeholder já
          identificam o campo, e o texto "E-mail" acima dele era repetição. */}
      {/* Sem halo de foco: o campo é o único do formulário, e o anel sobre o cartão de
          vidro pesava mais que o próprio campo. A borda escurece no foco — é o que
          mantém visível onde está o cursor de quem navega por teclado. */}
      <Input
        label="E-mail"
        hideLabel
        size="sm"
        focusRing={false}
        type="email"
        name="email"
        value={email}
        onChange={event => {
          setEmail(event.target.value);
          onChange();
        }}
        error={error}
        placeholder="nome@empresa.com"
        adornment={<MailIcon />}
        autoComplete="email"
        autoFocus
        required
        disabled={submitting}
      />

      {/* Só o ícone de entrar. O nome acessível fica no `aria-label`: sem texto
          visível, é ele que dá ao botão um nome para leitor de tela — e continua
          dizendo o que a ação faz (o código chega por e-mail). */}
      <Button type="submit" variant="gradient" size="lg" fullWidth loading={submitting} aria-label="Enviar código">
        {submitting ? null : <SignInIcon className="size-5" />}
      </Button>
    </form>
  );
}
